import * as React from "react";
const SvgFiBrandsMicrosoft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-microsoft_svg__a)">
      <path d="M11.432 0H.046v11.428h11.386zM23.954 0H12.639v11.428h11.315zM11.432 12.572H.046V24h11.386zM23.954 12.572H12.639V24h11.315z" />
    </g>
    <defs>
      <clipPath id="fi-brands-microsoft_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsMicrosoft;
